import { Controller } from "@hotwired/stimulus"
import Tribute from "tributejs"

export default class extends Controller {
  connect() {
    this.tribute = new Tribute({
      trigger: '#',
      values: (text, cb) => {
        const query = text.trim()
        if (query.length < 1) {
          cb([])
          return
        }

        fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`)
          .then(response => response.json())
          .then(data => cb(data))
      },
      menuItemTemplate: (item) => {
        return `<span class="tribute-item">
          <strong>${item.original.sigla}</strong>
          <small>${item.original.descricao}</small>
        </span>`
      },
      selectTemplate: (item) => {
        return item.original.sigla
      },
      noMatchTemplate: () => '<span style="display: none;"></span>',
      menuContainer: document.body,
      lookup: 'sigla',
      fillAttr: 'sigla'
    })

    this.tribute.attach(this.element)
  }

  disconnect() {
    if (this.tribute) {
      this.tribute.detach(this.element)
    }
  }

  get urlValue() {
    return this.element.dataset.siglasUrlValue
  }
}
